export default {
    namespaced: true,
    state: {
        regionData:'',
        indexData:''
    },
    getters: {
        getRegionData(state){
            
            return state.regionData;
        },
        getIndexData(state){
            
            return state.indexData;
        }
    },
    actions: {
        increment(context) {
            context.commit('increment')
        }
    },
    mutations: {
        setRegionData(state, regionData) {
        
            state.regionData = regionData
        },
        setIndexData(state, indexData) {
        
            state.indexData = indexData
        },
    },
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js